<template>
    <div class="date-picker-container" :class="{ 'read-only': readOnly, error: errorHighlight }">
        <label v-if="label" :class="{ focused: isFocused }">
            <span v-show="required && !readOnly" class="text-secondary">*</span>
            {{ label }}
        </label>
        <el-date-picker
            @change="handleChanges"
            @focus="handleFocus"
            @blur="handleBlur"
            v-model="date"
            size="large"
            format="dd/MM/yyyy"
            value-format="yyyy-MM-dd"
            align="center"
            type="date"
            :editable="false"
        />
    </div>
</template>

<script>
import 'vue-awesome/icons/chevron-right'

export default {
    name: 'ci-input',
    props: {
        value: {
            type: String,
        },
        label: {
            type: String,
        },
        required: {
            type: Boolean,
        },
        readOnly: {
            type: Boolean,
            default: false,
        },
        errorHighlight: {
            type: Boolean,
            default: false,
        },
    },
    watch: {
        value: {
            handler: function () {
                this.date = this.value
            },
            deep: true,
            immediate: true,
        },
    },
    data() {
        return {
            date: '',
            isFocused: false,
        }
    },
    methods: {
        handleChanges(value) {
            this.$emit('input', value)
        },
        handleFocus() {
            this.isFocused = true
        },
        handleBlur() {
            this.isFocused = false
        },
    },
}
</script>

<style lang="scss">
@import '@/scss/components/Utils/custom-date-picker.scss';
</style>
